const Courier = () => {
    return (
        <>
            Courier
        </>
    )

};

export default Courier;